import {FC} from 'react';
import styles from '../DemoRegistration.module.scss';

interface Props {
  icon: string;
  title: string;
  required?: boolean;
}

export const SectionHeader: FC<Props> = ({icon, title, required}) => {
  return (
    <div className={styles.sectionHeader}>
      <div className={styles.sectionHeaderIconWrap}>
        <img src={icon} alt="" className={styles.sectionHeaderIcon} />
      </div>
      <h2 className={styles.sectionHeaderTitle}>{title}</h2>
      {required ? <span className={styles.requiredMark}>*</span> : null}
    </div>
  );
};
